<script lang="ts" setup>

const route = useRoute();
const chatStore = useChatStore();

let isIframe = ref(false);
let isPreviewMode = ref(false);
let promptVersion = ref('');

if (route.query.isIframe) {
  isIframe.value = true;
}

// プレビューモードの検出
if (route.query.prompt_version) {
  isPreviewMode.value = true;
  promptVersion.value = route.query.prompt_version as string;
  console.log('Preview mode activated with prompt_version:', promptVersion.value);
}

chatStore.isIframe = isIframe.value;
chatStore.promptVersion = promptVersion.value;

console.log('isIframe', isIframe.value);
</script>


<template>
  <div id="aichat-container" :class="{ 'dsp-iframe': isIframe }">
    <!-- プレビューモード表示 -->
    <div v-if="isPreviewMode" class="preview-mode-banner">
      <div class="preview-info">
        <h3>🔍 プロンプトプレビューモード</h3>
        <p>選択されたプロンプトバージョン: <code>{{ promptVersion }}</code></p>
        <p class="preview-note">※ このチャットでは管理画面で選択したプロンプトバージョンが使用されます</p>
      </div>
    </div>

    <ChatWindow />
    <IconChatStart />
  </div>
</template>

<style>
@reference "@/assets/css/tailwind.css";

.dsp-iframe {

  .aichat-icon,
  .aichat-icon-small {
    top: 0px;
    left: 0px;
    right: inherit;
    bottom: inherit;
  }

  .aichat-icon>button:first-child img,
  .aichat-icon-small img {
    width: 100% !important;
  }

  .aichat-window {
    position: inherit;
  }

}

/* プレビューモードバナー */
.preview-mode-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 15px 20px;
  margin-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.preview-info h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: bold;
}

.preview-info p {
  margin: 5px 0;
  font-size: 14px;
}

.preview-info code {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 3px;
  font-family: monospace;
  font-size: 13px;
}

.preview-note {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 8px;
}

/* 関連情報ツールチップ */
.reference-link {
  padding: 6px;
}

.reference-link p {
  margin: 0px;
  padding: 0px;
}

.reference-link p.title {
  font-weight: bold;
}

.reference-link p.url {
  font-size: small;
}

.reference-link a,
.chat-answer-container a {
  @apply font-medium;
  @apply text-[#194593];
  @apply hover:underline;
  @apply hover:text-[#C70026];
}

.v-popper--theme-tooltip {
  .v-popper__inner {
    @apply text-sm;
  }
}

.v-popper__inner {
  max-height: 400px;
}
</style>